import axios from 'axios'
import React, { useEffect, useState } from 'react'
import classesHM from './helpMenu.module.css'
import classes from './Redesign/Sidebar/Sidebar.module.css'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

const HelpMenu = () => {
  const [helpMenu, setHelpMenu] = useState(null)
  const [activeMenuItem, setActiveMenuItem] = useState(null)

  const toggleMenu = (menuItem) => {
    setActiveMenuItem((prev) => (prev === menuItem ? null : menuItem))
  }

  useEffect(() => {
    const getHelpMenu = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/help-menu?type=help`)
        setHelpMenu(response.data)
      } catch (err) {
        console.error('Error fetching help menu:', err)
      }
    }

    getHelpMenu()
  }, [])

  return (
    <div className={classesHM.wrapper}>
      <div className={classes.linksContainer}>
        <div className={classes.innerMenu}>
          {helpMenu?.map((section, index) => (
            <div key={index} className={classes.menuItem}>
              <button
                onClick={() => toggleMenu(section._id)}
                className={`${classes.menuButton} ${
                  activeMenuItem === section._id ? classes.activeMenuItem : ''
                }`}
              >
                {section.title}
                {section.items.length > 0 && (
                  <div className={`imageWrapper ${classes.submenuIconWrapper}`}>
                    <img src='/icons/submenu-active.svg' alt='submenu icon' />
                  </div>
                )}
              </button>

              {activeMenuItem === section._id && section.items.length > 0 && (
                <div className={classes.submenu}>
                  {section.items.map((item, itemIndex) => (
                    <button
                      key={itemIndex}
                      onClick={() => (window.location.href = item.url)}
                      className={classes.submenuButton}
                    >
                      {item.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HelpMenu
